import { useRouter } from "next/router";
import { useMemo } from "react";

interface TossPromotionMessage {
  title: string;
  benefit: string;
  showNotice: boolean;
}

/**
 * 토스 프로모션 쿼리 파라미터를 기반으로 배너 메시지를 생성하는 훅
 *
 * @returns {TossPromotionMessage} 프로모션 title, benefit, showNotice
 */
export const useTossPromotionMessage = (): TossPromotionMessage => {
  const router = useRouter();
  const { promotion_discount, promotion_point, promotion_discount_cpa } =
    router.query;

  return useMemo(() => {
    const isPromotionDiscountCpaProcess = Boolean(promotion_discount_cpa);

    const isPromotionPointProcess =
      promotion_point && promotion_point !== "0" && Number(promotion_point) > 0;

    const isPromotionDiscountProcess =
      promotion_discount &&
      promotion_discount !== "0" &&
      Number(promotion_discount) > 0 &&
      Number(promotion_discount) < 100;

    if (isPromotionDiscountCpaProcess) {
      return {
        title: "토스페이 유저에게만 드리는 혜택!",
        benefit: `특별한 할인 혜택을`,
        showNotice: false,
      };
    }

    if (isPromotionPointProcess) {
      return {
        title: "토스페이 유저에게만 드리는 혜택!",
        benefit: `토스포인트 적립 혜택을`,
        showNotice: true,
      };
    }

    if (isPromotionDiscountProcess) {
      return {
        title: "오늘 하루만 드리는 토스페이 혜택!",
        benefit: `${promotion_discount}% 할인 혜택을`,
        showNotice: false,
      };
    }

    return {
      title: "토스페이 유저에게만 드리는 혜택!",
      benefit: "토스포인트 적립 혜택을",
      showNotice: true,
    };
  }, [promotion_point, promotion_discount, promotion_discount_cpa]);
};
